import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import VisibilityToggle from '../toggle';
import Chip from '../../../../../../components/chip';
import { Category } from '../../types';

import * as S from './styles';

type Props = {
  categories?: Category[];
  limit?: number;
};

type State = {
  collapse: boolean;
};

class SubCategoryInlineList extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      collapse: true,
    };
  }

  render() {
    const { collapse } = this.state;
    const { categories = [], limit = 6 } = this.props;
    return (
      <S.RelatedResources>
        {categories.map((cat, index) =>
          index < limit || !collapse ? (
            <Chip key={cat.id}>
              <Link to={cat.pathName}>{cat.name}</Link>
            </Chip>
          ) : null
        )}
        {categories && categories.length > limit && (
          <VisibilityToggle
            styling="small"
            active={!collapse}
            onToggle={() => this.setState({ collapse: !collapse })}
            label={
              collapse
                ? this.context.t('category', 'subcategories.show-more')
                : this.context.t('category', 'subcategories.show-less')
            }
          />
        )}
      </S.RelatedResources>
    );
  }
}

SubCategoryInlineList.contextType = AppContext;

export default SubCategoryInlineList;
